import CbInput from './src/input.vue';

CbInput.install = function(Vue) {
  Vue.component(CbInput.name, CbInput);
};

export default CbInput;
